import React, { useState, useEffect, memo } from "react";
import { Table, Typography, Select, Button, Result, Tooltip } from "antd";
import { UserOutlined, CarOutlined, HomeOutlined } from "@ant-design/icons";

const RiderMapBO = (props) => {
  const [active, setActive] = useState(false);

  const FilterClickHandler = (v) => {
    props.setFilter(v)
    setActive(v);
  }

  return (
    <div className="riderMapBO">
      {props?.iframeTag}
      <div className="bo-child">
        <div className={active == "all" ? "active" : ""} onClick={()=>FilterClickHandler('all')}>
          <p>{props?.postData?.all}</p>
          <UserOutlined style={{color: "#facc06"}}/>
          <p>Driver</p>
        </div>
        <div className={active == "free" ? "active" : ""} onClick={()=>FilterClickHandler('free')}>
          <p>{props?.postData?.free}</p>
          <CarOutlined style={{color: "#008000"}}/>
          <p>Free</p>
        </div>
        <div className={active == "returning" ? "active" : ""} onClick={()=>FilterClickHandler('returning')}>
          <p>{props?.postData?.returning}</p>
          <CarOutlined style={{color: "#800080"}}/>
          <p>Returning</p>
        </div>
        <div className={active == "assigned" ? "active" : ""} onClick={()=>FilterClickHandler('assigned')}>
          <p>{props?.postData?.assigned}</p>
          <CarOutlined style={{color: "#FFA500"}}/>
          <p>Assigned</p>
        </div>
        <div className={active == "in_Progress" ? "active" : ""} onClick={()=>FilterClickHandler('in_Progress')}>
          <p>{props?.postData?.in_Progress}</p>
          <CarOutlined style={{color: "#FF0000"}}/>
          <p>In Progress</p>
        </div>
        <div className={active == "break" ? "active" : ""} onClick={()=>FilterClickHandler('break')}>
          <p>{props?.postData?.break}</p>
          <CarOutlined style={{color: "#0000FF"}}/>
          <p>Break</p>
        </div>
        {/* <div onClick={()=>FilterClickHandler('delayed')}>
          <p>{props?.postData?.delayed}</p>
          <CarOutlined style={{color: "#f5936d"}}/>
          <p>Delayed</p>
        </div> */}
        <div className={active == "offline" ? "active" : ""} onClick={()=>FilterClickHandler('offline')}>
          <p>{props?.postData?.offline}</p>
          <CarOutlined style={{color: "#000"}}/>
          <p>Offline</p>
        </div>
        {/* <div>
          <p>{props?.bo?.driverCount}</p>
          <UserOutlined style={{color: props?.bo?.color}}/>
          <p>{props?.bo?.title}</p>
        </div>
        {props?.bo?.driverDetail.map((item)=>{
          return (<div>
            <p>{item?.driverCount}</p>
            <CarOutlined style={{color: item?.color}}/>
            <p>{item?.title}</p>
          </div>)
        })} */}
        <div className={active == "offline" ? "active" : ""}>
          <p>{" "}</p>
          <HomeOutlined style={{color: "#964B00", padding: "20%"}}/>
          <p>Store</p>
        </div>
      </div>
    </div>
  );
};

export default memo(RiderMapBO);
